import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["sidebar"]

  connect() {
    // Close the sidebar when clicking outside on mobile
    document.addEventListener("click", this.closeSidebar.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.closeSidebar.bind(this))
  }

  toggle(event) {
    event.stopPropagation()
    this.sidebarTarget.classList.toggle("hidden")
    this.sidebarTarget.classList.toggle("flex")
  }

  closeSidebar(event) {
    // Only close if we're on mobile and clicking outside the sidebar
    if (window.innerWidth < 768 && !this.element.contains(event.target)) {
      this.sidebarTarget.classList.add("hidden")
      this.sidebarTarget.classList.remove("flex")
    }
  }
}
